import { collection, getDocs, query, where, serverTimestamp } from 'firebase/firestore';
import { db } from './config';
import { createExperience } from './experienceService';

/**
 * Seed experiences if the collection is empty
 */
export const seedExperiences = async () => {
    try {
        // Check if experiences already exist
        const experiencesCollection = collection(db, 'experiences');
        const snapshot = await getDocs(experiencesCollection);

        if (snapshot.empty) {
            console.log('Seeding experiences collection...');

            // Define initial experiences (newest first)
            const initialExperiences = [
                {
                    company: 'DreamOnline Ltd.',
                    position: 'Senior Development Manager',
                    location: 'Baridhara, Dhaka, Bangladesh',
                    startDate: '2021-07',
                    endDate: '',
                    descriptions: [
                        'Directed end-to-end delivery of 20+ production products across the full stack (mobile, web, backend, AI/ML), leading cross-functional teams of up to 30 engineers and owning architecture and release decisions.',
                        'Reduced regression and crash rates by institutionalizing mandatory code reviews, CI/CD pipelines (Fastlane, GitHub Actions), and automated test gates across all teams.',
                        'Drove the company\'s expansion into AI/ML, delivering a facial-recognition platform (liveness + expression detection) and a YOLO-based object-flow system trained on 20,000+ samples.',
                        'Accelerated cross-platform delivery by introducing Flutter for two products (KAYI marketplace, MangoRides ride-hailing), shipping iOS and Android from one codebase.'
                    ],
                    website: '',
                    companyLogo: '',
                },
                {
                    company: 'DreamOnline Ltd.',
                    position: 'Mobile App Development Team Lead',
                    location: 'Baridhara, Dhaka, Bangladesh',
                    startDate: '2019-08',
                    endDate: '2021-06',
                    descriptions: [
                        'Led 9 mobile developers to deliver 3 enterprise products in 2 years, owning sprint planning, code review, and release cycles for Japanese-market apps (Webgym, EverGreen, Cawachi, OASIS LINK).',
                        'Raised unit-test coverage from 30% to 60% via weekly TDD and code-review sessions, reducing production defects.',
                        'Promoted to Mobile App Development Team Lead within 5 months after rewriting a legacy Objective-C product to Swift 5 and migrating it from MVC to MVVM.'
                    ],
                    website: '',
                    companyLogo: '',
                },
                {
                    company: 'Proficient Information Systems',
                    position: 'Senior Software Engineer (Team Lead)',
                    location: 'Mohakhali, Dhaka, Bangladesh',
                    startDate: '2016-09',
                    endDate: '2019-07',
                    descriptions: [
                        'Led a mobile team delivering iOS and Android apps for international clients, shipping FutureVault (secure document platform) and 4 additional products with release pipelines to the App Store and Google Play.',
                        'Improved app load time by 2x and eliminated UI-freeze defects by refactoring legacy iOS code and resolving memory leaks.',
                        'Hardened app security with certificate pinning, biometric authentication, Proguard obfuscation, and FCM.'
                    ],
                    website: '',
                    companyLogo: '',
                },
                {
                    company: 'W3Engineers',
                    position: 'Senior Software Engineer (Team Lead)',
                    location: 'Khulna, Bangladesh',
                    startDate: '2014-08',
                    endDate: '2016-07',
                    descriptions: [
                        'Grew the active user base of YO!, a WiFi-based offline messaging app, by ~500,000 users within a 28-engineer team, leading code review and merge management.',
                        'Engineered internet-free real-time chat and file sharing via TCP/UDP communication over local WiFi networks in Java.',
                        'Selected to represent W3Engineers at Mobile World Congress (MWC) 2015 in Barcelona, Spain, showcasing the YO! application.'
                    ],
                    website: '',
                    companyLogo: '',
                },
                {
                    company: 'Graphic Associate (MindWorking Asia) · MapleDew · Softworks',
                    position: 'Software Developer → Android Developer → Jr. Software Developer',
                    location: 'Dhaka, Bangladesh',
                    startDate: '2011-10',
                    endDate: '2014-07',
                    descriptions: [
                        'Progressed across three early-career roles building Android and iOS apps, Cocos2D games, and Augmented Reality features (Vuforia, NDK).',
                        'Integrated Google Maps API and built a multi-threaded SMS/contacts sync manager.'
                    ],
                    website: '',
                    companyLogo: '',
                }
            ];

            // Create each experience in reverse order to maintain chronological display
            for (let i = initialExperiences.length - 1; i >= 0; i--) {
                await createExperience(initialExperiences[i]);
            }

            console.log('Successfully seeded experiences collection!');
        } else {
            console.log('Experiences collection already has data, skipping seed operation.');
        }
    } catch (error) {
        console.error('Error seeding experiences:', error);
    }
}; 